import jwtDecode from 'jwt-decode';
import Resource from '@guestyci/agni';
import { GUESTY_USER_DATA_KEY } from './consts';
import { isObj } from './helpers';

export const extractPreferencesFromObject = obj => {
  if (!isObj(obj)) {
    return undefined;
  }
  const { locale, localizedFormatsMap } = obj;
  if (!isObj(localizedFormatsMap)) {
    return undefined;
  }
  return { locale, localizedFormatsMap };
};

export const readGuestyUserDataObject = () => {
  try {
    const raw = window.localStorage.getItem(GUESTY_USER_DATA_KEY);
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw);
    return isObj(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

const writePreferencesBlock = (locale, localizedFormatsMap) => {
  try {
    const base = readGuestyUserDataObject() ?? {};
    window.localStorage.setItem(
      GUESTY_USER_DATA_KEY,
      JSON.stringify({
        ...base,
        preferences: {
          locale,
          dateTimeFormat: localizedFormatsMap,
        },
      })
    );
  } catch {
    console.error('Failed to rewrite user preferences on localStorage');
  }
};

const fetchPreferences = async accessToken => {
  try {
    const userId = jwtDecode(accessToken)?.userId;
    if (!userId) {
      throw new Error();
    }
    const { api } = Resource.create({ domain: '/' });
    const { data } = await api.get(`/user-preferences/${userId}`);
    return extractPreferencesFromObject(data);
  } catch {
    console.error('Failed to fetch user preferences');
    return undefined;
  }
};

export const saveUserPreferences = async ({
  accessToken,
  preferences,
} = {}) => {
  if (!accessToken || typeof accessToken !== 'string') {
    console.error(
      'Failed to save user preferences: invalid or missing access token passed'
    );
    return;
  }

  const existingPreferences = extractPreferencesFromObject(preferences);
  const resolvedPreferences =
    existingPreferences ?? (await fetchPreferences(accessToken));

  if (resolvedPreferences) {
    writePreferencesBlock(
      resolvedPreferences.locale,
      resolvedPreferences.localizedFormatsMap
    );
  }
};
